import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { createNavigationItems } from '@app/client-specific/header/navigation-items';
import { Authenticator } from '@app/core/authentication/services/authenticator.service';
import { User } from '@app/shared/models/user.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

function getViewerUrlTree(viewer: User | null, router: Router): UrlTree {
    const path = getViewerHomepage(viewer);

    return router.createUrlTree([path]);
}

function getViewerHomepage(viewer: User | null): string {
    const viewerRole = viewer?.role;

    if (!viewerRole) {
        return '/authentication/welcome';
    }

    const navigationItems = createNavigationItems(viewerRole);

    if (0 === navigationItems.length) {
        throw new Error(
            `There must be at least one navigation item for the role ${viewerRole}, but none were found.`,
        );
    }

    return navigationItems[0].url;
}

@Injectable({
    providedIn: 'root',
})
export class RedirectToViewerHomepageGuard implements CanActivate {

    constructor(
        private readonly authenticator: Authenticator,
        private readonly router: Router,
    ) {
    }

    canActivate(): Observable<UrlTree> {
        return this.authenticator.getViewer()
            .pipe(
                map((viewer) => getViewerUrlTree(viewer, this.router)),
            );
    }
}
